module.exports = __webpack_public_path__ + "fonts/sourcesansprolight.bd382885.woff";